import React from 'react'
import ButtonBase from './ButtonBase'

export interface ButtonPrimaryProps {
  children?: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  fullWidth?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  shape?: 'rectangle' | 'square' | 'circle'
  size?: 'small' | 'medium' | 'large'
  letter?: string
  style?: React.CSSProperties
  ariaLabel?: string
  'data-testid'?: string
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  children,
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  shape = 'rectangle',
  size = 'medium',
  letter,
  style,
  ariaLabel,
  'data-testid': dataTestId
}) => {
  const hasChildren = Boolean(children)
  const iconElement = icon && <span className="flex items-center justify-center">{icon}</span>

  return (
    <ButtonBase
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      shape={shape}
      size={size}
      letter={letter}
      style={style}
      ariaLabel={ariaLabel}
      data-testid={dataTestId}
      className={`
        !bg-sun text-off-black hover:!bg-sun/90 focus:ring-sun/20 
        disabled:!bg-off-black disabled:text-white-30 
        border-2 border-sun-40 disabled:border-white-30
        flex items-center justify-center
        ${className}
      `}
    >
      {iconPosition === 'left' && iconElement}
      {iconPosition === 'left' && icon && hasChildren && <span className="ml-2">{children}</span>}
      {!icon && children}
      {iconPosition === 'right' && icon && hasChildren && <span className="mr-2">{children}</span>}
      {iconPosition === 'right' && iconElement}
    </ButtonBase>
  )
}

export default ButtonPrimary
